import React from 'react'
import './Instagram.sass'

const url = `https://api.instagram.com/oembed/?url=http://instagr.am/p/BgECELfl-Tb/`

const posts = [
  'BfyanZ0hpTa', 'BfvtMxUhIDW', 'BffqJR2h7K_', 'BfOZ5_NhVGU', 'BenaPVbBT2p', 'BeFw7G5BaeZ',
  'BcIJ2AZBKSB', 'Bb7LOPlBj8q', 'BbpOYwthHQc', 'BZvl2d4hGG0', 'BZV5qnxh77q', 'BatFQB5BVw6'
]

class Instagram extends React.Component {
  state = {
    post: null,
    opacity: 1,
  }

  componentDidMount() {
    this.refresh()
  }

  refresh = () => {
    const i = Math.round( Math.random() * posts.length ) - 1
    this.setState({ post: posts[i], opacity: 0 })
  }

  onLoad = () => {
    console.log('onLoad')
    this.setState({ opacity: 1 })
  }

  render() {
    const { post, opacity } = this.state

    return (
      <div className="Instagram">
        <button className={`Button--refresh${opacity ? '' : ' is-refreshing'}`} onClick={this.refresh} />
        { post &&
          <div>
            <iframe
              src={`//instagram.com/p/${post}/embed/`}
              style={{ opacity, transition: opacity ? '' : 'none' }}
              onLoad={this.onLoad}
            />
          </div>
        }
      </div>
    )
  }
}

export default Instagram



// WEBPACK FOOTER //
// ./src/components/Instagram/index.js